import { Api } from 'utils';

class PointService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/points/',params),
		save: async (params?: any) => Api.createResponse('admin/points/save',params),
	}
	
	static client = {
		get: async (params?: any) => Api.createResponse('client/points/',params),
		redeem: async (params?: any) => Api.createResponse('client/points/redeem',params),
	}

}

export default PointService;